import ClaimView from "./ClaimView";

export default ClaimView;
